import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "row mb-20" }
const _hoisted_6 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_7 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 5,
  class: "dropdown"
}
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.auth.can('BL_S') && _ctx.auth.can('ADD_BL_S'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
              type: "button",
              to: "/add-delivery-stock-notes"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Nouveau bon de livraison ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ])),
              _: 1,
              __: [6]
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Voir", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.filters.per_page,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.per_page) = $event)),
            options: [10, 25, 50],
            clearable: false,
            class: "per-page-selector d-inline-block mx-50",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRecords()))
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter())),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
          }, null, 544), [
            [_vModelText, _ctx.filters.searchTerm]
          ])
        ])
      ]),
      _createVNode(_component_vue_good_table, {
        columns: _ctx.columns,
        rows: _ctx.rows,
        loading: _ctx.isLoader
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [9]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field === 'note_stock_ref')
            ? (_openBlock(), _createElementBlock("b", _hoisted_8, _toDisplayString(props.row.note_stock_ref), 1))
            : (props.column.field === 'created_at')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                ], 64))
              : (props.column.field === 'note_stock_total_parcel')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(props.row.note_stock_total_parcel) + " Colis ", 1)
                  ], 64))
                : (props.column.field === 'note_stock_total_crbt')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(props.row.note_stock_total_crbt) + " DH ", 1)
                    ], 64))
                  : (props.column.field === 'note_stock_delivered')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        (props.row.note_stock_delivered == 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                props.row.note_stock_delivered
              )}`, "text-capitalize"])
                            }, " Nouveau ", 2))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                props.row.note_stock_delivered
              )}`, "text-capitalize"])
                            }, " Enregistré ", 2))
                      ], 64))
                    : (props.column.field === 'action')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[16] || (_cache[16] = _createElementVNode("button", {
                            class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_10, [
                            (_ctx.auth.can('BL_S'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                                  _createVNode(_component_router_link, {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    to: {
                      name: 'EditNoteBLStockPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_stock_ref,
                      },
                    }
                                  }, {
                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Modifier ", -1)
                                    ])),
                                    _: 2,
                                    __: [10]
                                  }, 1032, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.auth.can('BL_S') &&
                    props.row.note_stock_total_parcel == 0 &&
                    props.row.note_stock_delivered == 0
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.removeBL(props.row.id))
                                  }, _cache[11] || (_cache[11] = [
                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Supprimer ", -1)
                                  ]), 8, _hoisted_13)
                                ]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.auth.can('BL_S') &&
                    props.row.note_stock_delivered == 0 &&
                    props.row.note_stock_total_parcel != 0
                  )
                              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.saveBL(props.row.id))
                                  }, _cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Enregistrer ", -1)
                                  ]), 8, _hoisted_15)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", null, [
                              (
                      _ctx.auth.can('BL_S') && props.row.note_stock_total_parcel != 0
                    )
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.getPDF(props.row))
                                  }, _cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" PDF ", -1)
                                  ]), 8, _hoisted_16))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (
                      _ctx.auth.can('BL') && props.row.note_stock_total_parcel != 0
                    )
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.ticketsPDF(props.row))
                                  }, _cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "flaticon-menu lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Tickets ", -1)
                                  ]), 8, _hoisted_17))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (
                      _ctx.auth.can('BL') && props.row.note_stock_total_parcel != 0
                    )
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.tickets4PDF(props.row))
                                  }, _cache[15] || (_cache[15] = [
                                    _createElementVNode("i", { class: "flaticon-more-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Tickets 4*4 ", -1)
                                  ]), 8, _hoisted_18))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows", "loading"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.filters,
        offset: 9,
        onPaginate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getRecords()))
      }, null, 8, ["pagination"])
    ])
  ]))
}